import gql from "graphql-tag";

export const WEBLINK_LOCALES_QUERY = gql`
  query locales {
    store {
      multilingualCoursesEnabled
    }
    locales(order: { field: name, direction: asc }) {
      edges {
        node {
          id
          code
          name
          language
          default
        }
      }
    }
  }
`;
